import { format } from 'date-fns'
import { useGetTemplateActivityLogByIds } from './useGetTemplateActivityLogByIds'
import { useDownloadFile } from '../useDownloadFile'
import { ActivityLogV2Content } from './ActivityLogV2Content'

export type ActivityLogV2Props = {
  entityId: number
  templateId: number
  appId?: number
  projectId?: number
}

export function ActivityLogV2({ entityId, templateId, appId, projectId }: ActivityLogV2Props) {
  const { data: activityLog } = useGetTemplateActivityLogByIds({ entityId, templateId, appId, projectId })
  const { mutate: downloadFile, isPending } = useDownloadFile()

  const firstActivity = activityLog[0]
  const lastActivity = activityLog[activityLog.length - 1]

  if (!firstActivity || !lastActivity) return <div>No activity</div>
  const { user, date, url } = firstActivity
  const updatedText = `Updated ${user ? `by ${user} on` : ''} ${format(new Date(date), 'PPP')}`
  // const NextAction = renderNextAction(lastActivity)
  const handleDownloadTemplate = () => {
    downloadFile({ url: url, fileName: firstActivity.file_name })
  }
  return (
    <ActivityLogV2Content
      activityLog={activityLog}
      lastActivity={lastActivity}
      url={url}
      updatedText={updatedText}
      handleDownloadTemplate={handleDownloadTemplate}
      isPending={isPending}
      entityId={entityId}
      templateId={templateId}
    />
  )
}
